import request from '@/router/axios';

export function queryNewsList(type, obj) {
  return request({
    url: '/hrms/sys/home/queryNewsList/' + type,
    method: 'post',
    data: obj
  });
}
